export const formatarHorasDecimalParaHHMMSS = (horasDecimais) => {
  const totalSegundos = Math.round(horasDecimais * 3600);
  const horas = Math.floor(totalSegundos / 3600);
  const minutos = Math.floor((totalSegundos % 3600) / 60);
  const segundos = totalSegundos % 60;
  return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`;
};